// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Eg8dF","footer":"styles_footer__2mDoq"};